import {Component, OnInit} from '@angular/core';
import {CoachingService} from '../service/coaching.service';
import {ActivatedRoute} from '@angular/router';
import {CoachingFormModel} from '../model/coaching-form.model';
import {AlertController} from '@ionic/angular';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation, fadeInUpOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {EventsService} from '../../../services/events.service';
import {NavService} from '../../../services/nav.service';
import {TranslateService} from '@ngx-translate/core';
import {AnalyticsService} from '../../../services/analytics.service';
import {UserService} from "../../../services/user.service";

@Component({
    selector: 'app-coaching-details',
    templateUrl: './coaching-form.component.html',
    styleUrls: ['./coaching-form.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class CoachingFormComponent implements OnInit {

    public coachingId = 0;
    public delegateId = 0;
    public action = 'new';
    public level = 'learner';

    public dataForm: CoachingFormModel = null;
    public dataFormPromise: Promise<CoachingFormModel> = null;

    constructor(
        private analytics: AnalyticsService,
        private coachingService: CoachingService,
        private activatedRoute: ActivatedRoute,
        private alertController: AlertController,
        public userService: UserService,
        private event: EventsService,
        private translate: TranslateService,
        private nav: NavService,
    ) {
        this.level = this.activatedRoute.snapshot.data.level;
        this.action = this.activatedRoute.snapshot.data.action;
        if (this.action === 'edit') {
            this.coachingId = Number(this.activatedRoute.snapshot.paramMap.get('coachingId'));
            this.dataFormPromise = this.coachingService.getCoachingForm(this.coachingId);
        } else if (this.action === 'new') {
            if (this.level === 'manager') {
                this.delegateId = Number(this.activatedRoute.snapshot.paramMap.get('delegateId'));
            } else {
                this.delegateId = this.userService.getCurrentUserInfo().id;
            }
            this.dataFormPromise = this.coachingService.getCoachingNewForm(this.delegateId);
        } else {
            this.nav.navigate(['/home']);
        }
    }

    ngOnInit() {
    }

    ionViewDidEnter() {
        this.analytics.trackView('Coaching Form');

        this.dataFormPromise.then(data => {
            this.dataForm = data;
        });
    }

    onChange(event) {
        this.event.publish('form:changed', 'coaching');
    }

    onSave() {
        let completed = (this.dataForm.groups.value.filter(
            (group) => (group.questions.value.filter(
                (question) => question.value.value < 0)).length > 0).length === 0);
        if (this.dataForm.type === 'SELF') {
            completed = completed && !!this.dataForm.coachee_name.value;
        }
        if (completed) {
            this.saveForm();
        } else {
            this.alertController.create({
                header: this.translate.instant('__COACHING_WARNING_TITLE__'),
                message: this.translate.instant('__COACHING_WARNING_MESSAGE__'),
                buttons: [this.translate.instant('__COACHING_WARNING_BUTTON__')]
            }).then(a => a.present());
        }
    }

    saveForm() {
        this.coachingService.saveCoachingForm(this.dataForm)
            .then(data => {
                if (data.status !== null) {
                    this.event.publish('form:saved', {name: 'coaching', id: this.dataForm.id});

                    this.analytics.trackEvent('coaching_update', {
                        coaching_id: this.dataForm.id.toString()
                    });

                    this.alertController.create({
                        header: this.translate.instant('__ALERT_SUCCESS_TITLE__'),
                        message: this.translate.instant(data.status.message),
                        buttons: [{
                            text: this.translate.instant('__ALERT_SUCCESS_BUTTON__'),
                            handler: () => {
                                this.nav.back();
                            }
                        }]
                    }).then(a => a.present());
                } else {
                    this.dataForm = data.form;
                    this.analytics.trackEvent('exception', {
                        description: 'Coaching Form Save Error: ' + this.dataForm.error,
                        fatal: false
                    });
                    this.alertController.create({
                        header: this.translate.instant('__ALERT_ERROR_TITLE__'),
                        message: this.translate.instant(this.dataForm.error),
                        buttons: [this.translate.instant('__ALERT_ERROR_BUTTON__')]
                    }).then(a => a.present());
                }
            })
            .catch(e => {
                console.error('Error in saveCoachingForm', e);
                return null;
            });
    }
}
